import React, { useState } from 'react'
import { Button, Card, Image, Spinner } from 'react-bootstrap'
import { BsFillFileEarmarkPdfFill, BsPlusLg, BsXLg } from 'react-icons/bs'
import IconDownload from '../../../images/Action/Download.svg'
import IconView from '../../../images/pdf.svg'
import iconEdit from '../../../images/Edit.svg'
import ModaleditCertificate from './modal-edit-certificate'
import moment from 'moment'
import SwalCustom from '../../../alert/swal-custom'
import { useDropzone } from 'react-dropzone'
import {
  getTraingFileAPI,
  postTraingFileAPI
} from '../../../services/certificate'
import Error_false from '../../error/error-false'
import Error_500 from '../../error/error-500'
import Swal from 'sweetalert2'
import { TXTSUCCESS } from '../../../Constants'

function TableCertificate({
  keys,
  data,
  isFile,
  setIsSave,
  isSave,
  fnData,
  orgId,
  code
}) {
  const [onEdit, setOnEdit] = useState(false)
  const [filedoc, setFileDoc] = useState([])

  const handleEdit = () => {
    setOnEdit(true)
  }

  const handleClose = () => {
    setOnEdit(false)
  }

  const getFilesDocs = async (d) => {
    const param = {
      code,
      orgId,
      tnId: d.id
    }
    const result = await getTraingFileAPI(param)
    if (!result) return
    void window.open(result.result, '_blank')
  }

  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    maxSize: 8000000,
    accept: {
      // 'image/*': ['.png', '.jpg', '.jpeg', '.gif']
      'pdf/pdf': ['.pdf']
    },
    onDrop: (acceptedFiles) => {
      setFileDoc(acceptedFiles.map((file) => Object.assign(file)))
    },
    onDropRejected: () => {
      Swal.fire({
        icon: 'error',
        title: 'You can only upload 1 file & maximum size of 8 MB.',
        showConfirmButton: false,
        timer: 3000
      })
    }
  })

  const renderFilePreview = (file) => {
    if (file.type.startsWith('image')) {
      return (
        <img
          width={38}
          height={38}
          alt={file.name}
          src={URL.createObjectURL(file)}
        />
      )
    } else {
      return (
        <BsFillFileEarmarkPdfFill
          className="opacity-25 mt-2 mb-2"
          style={{
            fontSize: '2rem',
            marginLeft: '2px'
          }}
        />
      )
    }
  }
  const fileList = filedoc.map((file) => (
    <span key={file.name} className="d-flex justfy-content-center">
      <div className="w-100 ">
        <div>{renderFilePreview(file)}</div>
        <div className="my-auto ms-2">
          <p className="mb-0 small">{file.name}</p>
          <span className="font-small-2 fw-lighter">
            {' '}
            {Math.round(file.size / 100) / 10 > 1000
              ? `${(Math.round(file.size / 100) / 10000).toFixed(1)} mb`
              : `${(Math.round(file.size / 100) / 10).toFixed(1)} kb`}
          </span>
        </div>
      </div>
      <div onClick={() => handleRemoveFile(file)}>
        <BsXLg fontSize={20} />
      </div>
    </span>
  ))

  const updateFileWorks = async (d) => {
    setIsSave(true)

    try {
      var c_formData = new FormData()
      c_formData.append('file', filedoc[0])
      c_formData.append('orgId', orgId)
      c_formData.append('code', code)
      c_formData.append('tnId', d.id)

      const resp = await postTraingFileAPI(c_formData)
      if (!resp) return
      if (resp?.status) {
        SwalCustom({
          title: `Success!`,
          text: "Your Document has been attached",
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          setFileDoc([])
          fnData(orgId, code)
          // setShowAE(false)
        })
      } else {
        Error_false(resp)
      }
      setIsSave(false)
      fnData({ orgId, code })
    } catch (error) {
      Error_500(error)
      setIsSave(false)
    }
  }

  const handleRemoveAllFiles = () => {
    setFileDoc([])
  }

  const handleRemoveFile = (file) => {
    const uploadedFiles = filedoc
    const filtered = uploadedFiles.filter((i) => i.name !== file.name)
    setFileDoc([...filtered])
  }
  const htmlUploadFile = (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <>
        <Image
          style={{
            width: '16px'
          }}
          className="pointer-event"
          src={IconDownload}
        />
      </>
    </div>
  )
  return (
    <>
      <tr className="fw-light font-small-2" key={keys}>
        <td className="text-center">{keys + 1}</td>
        <td>{data.course_name}</td>
        <td>{data.course}</td>
        <td>{moment(data.start_date).format('DD/MM/YYYY')}</td>
        <td>{moment(data.end_date).format('DD/MM/YYYY')}</td>
        <td> {data.exp_status}</td>
        <td>{data.partner_name}</td>
        <td>{data.status}</td>
        <td>
          <span
            className={`${
              data.t_status_id === 1 ? 'text-success' : 'text-danger'
            }`}
          >
            {data.t_status}
          </span>
        </td>{' '}
        <td>{moment(data.insert_date).format('DD/MM/YYYY HH:mm')}</td>
        <td>
          <div className="text-center">
            {/* no file */}
            {isFile === 1 ? (
              <>
                {filedoc.length ? (
                  <div className="mt-3" style={{ width: '100%' }}>
                    <Card>{fileList}</Card>

                    <div className="mt-2 mt-3">
                      <Button
                        variant="outline-danger pointer-event"
                        disabled={isSave}
                        onClick={handleRemoveAllFiles}
                      >
                        นำออก
                      </Button>
                      <Button
                        disabled={isSave}
                        className="ms-3 pointer-event"
                        onClick={() => {
                          updateFileWorks(data)
                        }}
                      >
                        {isSave ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            className="me-2"
                            aria-hidden="true"
                          />
                        ) : (
                          <BsFillFileEarmarkPdfFill className="me-2" />
                        )}
                        {isSave ? 'กำลังบันทึกไฟล์...' : 'บันทึกไฟล์'}
                      </Button>
                    </div>
                  </div>
                ) : (
                  // <></>
                  <div className="d-flex gap-3 justify-content-center ">
                    <Image
                      className="pointer-event"
                      onClick={() => {
                        getFilesDocs(data)
                      }}
                      style={{ width: '18px' }}
                      src={IconView}
                    />
                    {htmlUploadFile}
                  </div>
                )}
              </>
            ) : (
              <>
                {/* have file */}

                <div className="d-flex justify-content-center">
                  {htmlUploadFile}
                </div>
                {filedoc.length ? (
                  <div className="mt-3" style={{ width: '100%' }}>
                    <Card>{fileList}</Card>

                    <div className="mt-3">
                      <Button
                        variant="outline-danger pointer-event"
                        disabled={isSave}
                        onClick={handleRemoveAllFiles}
                      >
                        นำออก
                      </Button>
                      <Button
                        disabled={isSave}
                        className="ms-3 pointer-event"
                        onClick={() => {
                          updateFileWorks(data)
                        }}
                      >
                        {isSave ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            className="me-2"
                            aria-hidden="true"
                          />
                        ) : (
                          <BsFillFileEarmarkPdfFill className="me-2" />
                        )}
                        {isSave ? 'กำลังบันทึกไฟล์...' : 'บันทึกไฟล์'}
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex gap-3 justify-content-center"></div>
                )}
              </>
            )}
          </div>
        </td>
        <td>
          <div className="text-center">
            <Image
              className="pointer-event"
              onClick={() => {
                handleEdit()
              }}
              src={iconEdit}
              style={{
                width: '20px'
              }}
            />
          </div>
        </td>
      </tr>
      {onEdit && (
        <ModaleditCertificate
          data={data}
          setIsSave={setIsSave}
          isSave={isSave}
          onEdit={onEdit}
          handleClose={handleClose}
          fnData={fnData}
          orgId={orgId}
          code={code}
        />
      )}
    </>
  )
}

export default TableCertificate
